export const AdminSharing = () => {
    return (
        <p>Sharing Page</p>
    )
}